import { MIXTURE_TANK_IMAGES } from '../../constants/mixtures.constants';
import styles from './MixtureTank.module.css';

interface MixtureTankProps {
	filled: boolean;
	size?: 'small' | 'large';
}

export const MixtureTank = ({ filled, size = 'small' }: MixtureTankProps) => (
	<img
		src={filled ? MIXTURE_TANK_IMAGES.full : MIXTURE_TANK_IMAGES.empty}
		alt={filled ? 'Caixa de injeção com mistura' : 'Caixa de injeção vazia'}
		className={`${styles.tank} ${size === 'large' ? styles.large : styles.small}`}
	/>
);
